import { render } from "./ResourceCountUsage.vue?vue&type=template&id=8ddb3c0c&scoped=true"
import script from "./ResourceCountUsage.vue?vue&type=script&lang=js"
export * from "./ResourceCountUsage.vue?vue&type=script&lang=js"

import "./ResourceCountUsage.vue?vue&type=style&index=0&id=8ddb3c0c&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ddb3c0c"]])

export default __exports__